import React from 'react';
import CompanyForm from '../components/CompanyForm';

const CreateCompany: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <CompanyForm mode="create" />
    </div>
  );
};

export default CreateCompany;
